<template>
  <div id="app" :class="{white:bg=='white',linear:bg=='linear'}">
    <Header></Header>
    <router-view v-if="show"></router-view>
    <Footer></Footer>
    <Service />
    <ValidWarn />
    <Notices />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
import Service from "./components/service.vue";
import ValidWarn from "@/components/validWarn";
import Notices from "@/components/notices";

// 白色背景的路由name
const whitebg = ["createbid", "setbid"];
// 渐变背景的路由name
const linear = ["creditCycle", "applyCredit"];

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Service,
    ValidWarn,
    Notices,
  },
  data() {
    return {
      show: true,
    };
  },
  provide() {
    return {
      $viewReload: this.$viewReload,
    };
  },
  created() {
    this.$store.dispatch("user/getUser", "all");
    this.$Message.config({
      top: 250,
      duration: 3,
    });
    window.addEventListener("focus", this.checkUser);
  },
  destroyed() {
    window.removeEventListener("focus", this.checkUser);
  },
  methods: {
    checkUser() {
      // 如果登录账户发生变化，重新获取用户数据
      let userId = localStorage.getItem("userId");
      if (userId != this.safe.Id) {
        this.$store.dispatch("user/getUser", "all");
        this.$viewReload();
      }
    },
    // 重载主视图
    $viewReload() {
      this.show = false;
      this.$nextTick(function () {
        this.show = true;
      });
    },
  },
  computed: {
    bg() {
      if (whitebg.indexOf(this.$route.name) > -1) return "white";
      if (linear.indexOf(this.$route.name) > -1) return "linear";
      return "";
    },
    safe() {
      return this.$store.state.user.safe;
    },
  },
};
</script>

<style lang='less'>
#app {
  position: relative;
  width: 100%;
  &.linear {
    background: url(./assets/linear_bg.png) 0 0 repeat-x #f1f2f5;
  }
  &.white {
    background: #fff;
  }
}
.daoqi {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-active1 {
  display: inline-block;
  position: relative;
  width: 14px;
  height: 14px;
  background: url("./assets/borrow/pic_info@2x.png") no-repeat;
  background-size: cover;
  background-position: 0, 0;
  margin-left: 5px;
}
</style>


